<div class="prospects-page p-fluid">
    <app-page-shell>
        <p-toast></p-toast>
        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


        <app-page-hero eyebrow="CRM Pipeline" title="Prospects" subtitle="Manage qualified opportunities, preserve intake context, and convert clean data into clients.">
            <div actions>
                <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadProspects()"></p-button>
                <p-button label="New Prospect" icon="pi pi-plus" (click)="openNew()"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

        <app-page-search-panel title="Search Prospects" [activeFilters]="activeSearchCount" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
            <div class="search-grid">
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectGlobalSearch" pInputText [ngModel]="searchText()" (ngModelChange)="setSearchText($event)" (keydown.enter)="applySearch()">
                            <label for="prospectGlobalSearch">Global Search</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectCompanySearch" pInputText [ngModel]="columnFilters()['companyName'] || ''" (ngModelChange)="setColumnFilter('companyName', $event)" (keydown.enter)="applySearch()">
                            <label for="prospectCompanySearch">Company</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectContactSearch" pInputText [ngModel]="columnFilters()['pocName'] || ''" (ngModelChange)="setColumnFilter('pocName', $event)" (keydown.enter)="applySearch()">
                            <label for="prospectContactSearch">Contact Person</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectEmailSearch" pInputText [ngModel]="columnFilters()['pocEmail'] || ''" (ngModelChange)="setColumnFilter('pocEmail', $event)" (keydown.enter)="applySearch()">
                            <label for="prospectEmailSearch">Email</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectPhoneSearch" pInputText [ngModel]="columnFilters()['pocPhoneNumber'] || ''" (ngModelChange)="setColumnFilter('pocPhoneNumber', $event)" (keydown.enter)="applySearch()">
                            <label for="prospectPhoneSearch">Phone</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select inputId="prospectStatusSearch" [options]="statuses" optionLabel="label" optionValue="value" [ngModel]="statusFilter()" (ngModelChange)="setStatusFilter($event)" [showClear]="true" styleClass="w-full"></p-select>
                            <label for="prospectStatusSearch">Status</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-compass"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectSourceSearch" pInputText [ngModel]="sourceFilter()" (ngModelChange)="setSourceFilter($event)" (keydown.enter)="applySearch()">
                            <label for="prospectSourceSearch">Source</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-star"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="prospectQualitySearch" pInputText [ngModel]="columnFilters()['prospectQuality'] || ''" (ngModelChange)="setColumnFilter('prospectQuality', $event)" (keydown.enter)="applySearch()">
                            <label for="prospectQualitySearch">Quality</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
                <div class="field roles-field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
                        <p-iftaLabel class="chips-ifta-label">
                            <p-multiSelect
                                inputId="prospectRoleSearch"
                                [options]="crmRoles()"
                                optionLabel="label"
                                optionValue="value"
                                [ngModel]="roleFilters()"
                                (ngModelChange)="setRoleFilters($event)"
                                display="chip"
                                [filter]="true"
                                [showClear]="true"
                                appendTo="body"
                                styleClass="w-full roles-multiselect">
                            </p-multiSelect>
                            <label for="prospectRoleSearch">Business Roles</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-search-panel>

        <app-page-data-panel title="Prospect Directory" [subtitle]="lastUpdatedText" [resultText]="prospects().length + ' of ' + totalRecords() + ' records'">
            <p-table
                [value]="prospects()"
                [rows]="rows()"
                [paginator]="true"
                [lazy]="true"
                [totalRecords]="totalRecords()"
                [loading]="loading()"
                [rowHover]="true"
                dataKey="id"
                styleClass="p-datatable-sm p-datatable-gridlines prospects-data-table"
                [tableStyle]="{ 'min-width': '62rem' }"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} prospects"
                [showCurrentPageReport]="true"
                (onLazyLoad)="loadProspects($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="prospectNumber" style="width: 9rem">Prospect <p-sortIcon field="prospectNumber"></p-sortIcon></th>
                        <th pSortableColumn="companyName">Company Profile <p-sortIcon field="companyName"></p-sortIcon></th>
                        <th pSortableColumn="pocName">Contact <p-sortIcon field="pocName"></p-sortIcon></th>
                        <th pSortableColumn="prospectQuality">Qualification <p-sortIcon field="prospectQuality"></p-sortIcon></th>
                        <th>Ownership / Updates</th>
                        <th class="text-center" style="width: 8rem">Actions</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-prospect>
                    <tr>
                        <td>
                            <div class="stack-cell prospect-identity">
                                <span class="code-pill">{{ prospect.prospectNumber || 'NEW' }}</span>
                                <p-tag [value]="prospect.status" [severity]="getSeverity(prospect.status)" class="uppercase font-bold"></p-tag>
                            </div>
                        </td>
                        <td>
                            <div class="stack-cell">
                                <a class="link-button cell-title" [routerLink]="['/crm/prospects', prospect.id]">{{ prospect.companyName }}</a>
                                <span class="cell-subtitle" *ngIf="prospect.customerNameLocal">{{ prospect.customerNameLocal }}</span>
                                <div class="flex flex-wrap gap-1" *ngIf="prospect.roles?.length">
                                    <p-tag *ngFor="let role of prospect.roles" [value]="roleLabel(role)" severity="contrast"></p-tag>
                                </div>
                                <div class="cell-meta">
                                    <span><i class="pi pi-briefcase"></i>{{ prospect.businessType || 'Business n/a' }}</span>
                                    <span><i class="pi pi-map-marker"></i>{{ prospect.city || 'City n/a' }}</span>
                                    <span><i class="pi pi-compass"></i>{{ prospect.source || 'Source n/a' }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="stack-cell">
                                <span class="cell-title">{{ prospect.pocName || '-' }}</span>
                                <div class="cell-meta vertical">
                                    <span><i class="pi pi-envelope"></i>{{ prospect.pocEmail || '-' }}</span>
                                    <span><i class="pi pi-phone"></i>{{ prospect.pocPhoneNumber || prospect.mobileNumber || '-' }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="stack-cell">
                                <span class="quality-pill">{{ prospect.prospectQuality || '-' }}</span>
                                <div class="cell-meta vertical">
                                    <span><i class="pi pi-sitemap"></i>{{ prospect.natureOfBusiness || 'Nature n/a' }}</span>
                                    <span><i class="pi pi-receipt"></i>{{ prospect.taxRegNumber || prospect.crNumber || 'Compliance n/a' }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="stack-cell">
                                <span class="cell-title">{{ prospect.salesTeamName || prospect.kamCustomerId || 'Unassigned' }}</span>
                                <div class="cell-meta vertical">
                                    <span><i class="pi pi-user"></i>Created by {{ prospect.createdByCustomerName || prospect.createdByCustomerId || '-' }}</span>
                                    <span><i class="pi pi-clock"></i>{{ prospect.updatedAt ? (prospect.updatedAt | date:'medium') : 'Not updated' }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="row-actions">
                                <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-text p-button-info" [routerLink]="['/crm/prospects', prospect.id]" pTooltip="View Details"></button>
                                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="editProspect(prospect)" pTooltip="Edit"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="deleteProspect(prospect)" pTooltip="Delete"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">
                            <div class="empty-state">
                                <i class="pi pi-search"></i>
                                <strong>No prospects found</strong>
                                <span>No matching prospect records.</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    </app-page-shell>
</div>
